import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ReturnRequestTable from "./returnRequestTable";
import { SearchAndFilterToolbar, StatusBar } from "../common";
import PageBodyWrapper from "../../components/PageBodyWrapper";
import useApi from "../../api";
import enumChoice from "../../enum";
import moment from 'moment';

import { Paginator } from "../../components/common";
import OrderFilter from "./orderFilter";
import { handleRetriveError } from "../../utils";

interface OrderResponse {
  results: any[]; 
}

function ReturnRequestMain() {
  const [openOrderFilterModal, setOpenOrderFilterModal] = useState(false);
  const [returnRequests, setReturnRequests] = useState<OrderResponse | null>(null);
  const [filterData, setFilterData] =  useState<any>({});

  const [searchParams, setSearchParams] = useSearchParams();
  const api = useApi();

  const changeStatus = (status: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("status", status);
    newParams.set("page", "1"); 
    setSearchParams(newParams);
  };

  const onDateRangeApply = (range: any) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", "1"); 

    const formattedStartDate = moment(range?.startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(range?.endDate).format('YYYY-MM-DD');

    newParams.set("created_at_before", formattedEndDate);
    newParams.set("created_at_after", formattedStartDate);
    setSearchParams(newParams);
  }

  const parseSearchParams = (params: URLSearchParams) => {
    const obj: { [key: string]: any } = {};
    params.forEach((value, key) => {
      obj[key] = value.includes(',') ? value.split(',') : value;
    });
    return obj;
  };

  const fetchReturnRequest = () => {
    const queryObject = parseSearchParams(searchParams);
    api.getReturnRequestList(queryObject).then(
      (response: any) => {
        setReturnRequests(response);
      },handleRetriveError);
  };

  useEffect(() => {
    fetchReturnRequest();
  }, [searchParams]);

  useEffect(() => {
    if (!searchParams.get("page")) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("page", "1");
      setSearchParams(newParams);
    };
    const queryObject = parseSearchParams(searchParams);
    setFilterData(queryObject)
  }, []);

  const currentPage = searchParams.get("page");
  const currentStatus = searchParams.get("status");

  const onPageChange = (page: number | any) => {
    if (!page) {
      return;
    }
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", page.toString());
    setSearchParams(newParams);
  }

  const onSearch = (e: any) => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set("search", e.target.value)
    setSearchParams(newParams)
  }


  const onFilterApply = (filters: any) => {
    const newParams = new URLSearchParams(searchParams);
    Object.keys(filters).forEach(key => {
      const value = filters[key];
      if (value) {
        newParams.set(key, value);
      } else {
        newParams.delete(key); 
      }
    });

    newParams.set("page", "1"); 
    setSearchParams(newParams);
    setOpenOrderFilterModal(!openOrderFilterModal)
  }

  return (
    <PageBodyWrapper>
      <StatusBar
        // onButtonClick={()=>setOpenModal(!openModal)}
        statusList={enumChoice.returnStatuses} 
        currentStatus={currentStatus || ''} 
        onChangeStatus={changeStatus} 
        // buttonLabel="Create Order"
      />
      <SearchAndFilterToolbar
        onDateRangeApply={onDateRangeApply}
        // onFilterOpen={() => setOpenOrderFilterModal(!openOrderFilterModal)}
      />      

      <div className="px-1">
        <ReturnRequestTable fetchReturnRequest={fetchReturnRequest} returnRequests={returnRequests?.results || []} />
      </div>

      <Paginator onPageChange={onPageChange} data={returnRequests} />


    </PageBodyWrapper>
  );
}

export default ReturnRequestMain;
